// import userAccountService from '@/services/user-account.service';

const state = {
    isToggle: false,
}

const mutations = {
    TOGGLE_SIDEBAR(state) {
        state.isToggle = !state.isToggle
    },
    SET_TOGGLE_STATE(state, isToggle) {
        state.isToggle = isToggle;
    }
}

const getters = {
    isToggle: state => state.isToggle
}

const actions = {

}

export default {
    state,
    mutations,
    getters,
    actions
}